<!--
@Time : 2020/12/1 1:29 下午
@Author : yekong
@File : shuilv.vue
@Software : PhpStorm
-->
<template>
  <div>
    <div class="shuilv">
      <div class="left">
        <div class="zsl">
          <div class="bg2"></div>
          <span>总税率</span>
        </div>
        <div class="zxsl">执行税率</div>
        <div class="zxsl">负担税率</div>
        <div class="zxsl2">
          <span></span>
          税率最低
        </div>
      </div>
      <div class="right">
        <div class="rhead">
          <div class="i"></div>
          <div class="i">公司</div>
          <div class="i">个人</div>
          <div class="i">土地增值</div>
          <div class="i">印花</div>
          <div class="i">房产</div>
          <div class="i">土地使用</div>
          <div class="i">增值</div>
          <div class="i">城市教育</div>
          <div class="i">社保</div>
        </div>
        <div class="rbody">
          <div class="item">
            <div class="item1">大连</div>
            <div class="item2">
              <div class="item2s hover">25%</div>
            </div>
            <div class="item2">
              <div class="item2s hover">25%</div>
            </div>
            <div class="item2">
              <div class="item2s">25%</div>
            </div>
            <div class="item2">
              <div class="item2s">25%</div>
            </div>
            <div class="item2">
              <div class="item2s">25%</div>
            </div>
            <div class="item2">
              <div class="item2s">25%</div>
            </div>
            <div class="item2">
              <div class="item2s">25%</div>
            </div>
            <div class="item2">
              <div class="item2s">25%</div>
            </div>
            <div class="item2">
              <div class="item2s">25%</div>
            </div>
          </div>
          <div class="item">
            <div class="item1">北京</div>
            <div class="item2">
              <div class="item2s hover">25%</div>
            </div>
            <div class="item2">
              <div class="item2s">25%</div>
            </div>
            <div class="item2">
              <div class="item2s">25%</div>
            </div>
            <div class="item2">
              <div class="item2s">25%</div>
            </div>
            <div class="item2">
              <div class="item2s">25%</div>
            </div>
            <div class="item2">
              <div class="item2s">25%</div>
            </div>
            <div class="item2">
              <div class="item2s">25%</div>
            </div>
            <div class="item2">
              <div class="item2s">25%</div>
            </div>
            <div class="item2">
              <div class="item2s">25%</div>
            </div>
          </div>
          <div class="item">
            <div class="item1">上海</div>
            <div class="item2">
              <div class="item2s hover">25%</div>
            </div>
            <div class="item2">
              <div class="item2s">25%</div>
            </div>
            <div class="item2">
              <div class="item2s">25%</div>
            </div>
            <div class="item2">
              <div class="item2s">25%</div>
            </div>
            <div class="item2">
              <div class="item2s">25%</div>
            </div>
            <div class="item2">
              <div class="item2s">25%</div>
            </div>
            <div class="item2">
              <div class="item2s">25%</div>
            </div>
            <div class="item2">
              <div class="item2s">25%</div>
            </div>
            <div class="item2">
              <div class="item2s">25%</div>
            </div>
          </div>
          <div class="item">
            <div class="item1">深圳</div>
            <div class="item2">
              <div class="item2s hover">25%</div>
            </div>
            <div class="item2">
              <div class="item2s">25%</div>
            </div>
            <div class="item2">
              <div class="item2s">25%</div>
            </div>
            <div class="item2">
              <div class="item2s">25%</div>
            </div>
            <div class="item2">
              <div class="item2s">25%</div>
            </div>
            <div class="item2">
              <div class="item2s">25%</div>
            </div>
            <div class="item2">
              <div class="item2s">25%</div>
            </div>
            <div class="item2">
              <div class="item2s">25%</div>
            </div>
            <div class="item2">
              <div class="item2s">25%</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "shuilv",
  data: function () {
    return {}
  },
  props: {
    top: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  created: function () {

  },
  filters: {},
  methods: {},
  mounted() {
  },
}
</script>

<style lang="scss" scoped>
.shuilv {
  margin-top: 20px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: nowrap;
  flex-direction: row;
  margin-left: 60px;

  .left {
    margin-top: 20px;
    margin-right: 40px;
  }

  .zsl {
    font-size: 36px;
    font-family: PingFang;
    font-weight: 800;
    color: #FFFFFF;
    position: relative;
    margin-bottom: 110px;
    width: 150px;

    .bg2 {
      width: 89px;
      height: 61px;
      background: #479BAF;
      position: absolute;
      z-index: 0;
    }

    span {
      position: absolute;
      z-index: 1;
      top: 20px;
      left: 20px;
    }

  }

  .zxsl {
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    margin-top: 70px;
  }

  .zxsl2 {
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    margin-top: 70px;

    span {
      width: 15px;
      height: 15px;
      background: #479BAF;
      display: inline-block;
    }
  }
}

.rhead {
  width: 1215px;
  height: 62px;
  background: #C7C9D3;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #0D1840;

  .i {
    width: 11.11%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: row;
  }
}

.rbody {
  .item {
    height: 71px;
    width: 1215px;
    border-bottom: 1px solid #81869B;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: row;

    .item1 {
      font-size: 30px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #57DBFF;
      width: 11.11%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: nowrap;
      flex-direction: row;
    }

    .item2 {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: nowrap;
      flex-direction: row;
      width: 11.11%;

      .item2s {
        font-size: 30px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        width: 94px;
        height: 55px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: nowrap;
        flex-direction: row;

      }

      .item2s.hover {
        background: linear-gradient(0deg, #479AAE 0%, #306783 100%);
      }
    }
  }
}
</style>
